import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/industries/healthcare')({
  head: () => ({
    ...buildSeoHead({ path: '/industries/healthcare', ...ROUTE_META['/industries/healthcare'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Industries', path: '/industries' }, { name: 'Healthcare', path: '/industries/healthcare' }])),
      jsonLdScript(buildWebPageSchema({ path: '/industries/healthcare', ...ROUTE_META['/industries/healthcare'] })),
    ],
  }),
});
